
import { defineComponent } from "vue";

export default defineComponent({
  name: "ResultSuccess",
  props: {
    withAmendments: Boolean,
  },
});
